export default __webpack_public_path__ + "static/media/Vesko_picture.ad8e6e9b.jpg";